import React from "react";
import Svg from "./svg";

export default class RepeatIcon extends Svg {
    render() {
        return (
            <svg
                className="repeat-icon"
                width="32"
                height="32"
                enableBackground="new 0 0 32 32"
                version="1.1"
                viewBox="0 0 32 32"
                xmlSpace="preserve"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                style={{
                    marginRight: "8px"
                }}>

                <g fill={this.props.color}>
                    <path d="M27.877,19.662c0.385-1.23,0.607-2.531,0.607-3.884c0-7.222-5.83-13.101-13.029-13.194v4.238    c4.863,0.093,8.793,4.071,8.793,8.956c0,0.678-0.088,1.332-0.232,1.966l-3.963-1.966l2.76,8.199l8.197-2.762L27.877,19.662z"/>
                    <path d="M7.752,16.222c0-0.678,0.088-1.332,0.232-1.967l3.963,1.967l-2.76-8.199L0.99,10.785l3.133,1.553    c-0.384,1.23-0.607,2.531-0.607,3.885c0,7.223,5.83,13.1,13.03,13.194v-4.238C11.682,25.086,7.752,21.107,7.752,16.222z"/>
                </g>
            </svg>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/svg/repeat.js
 **/